import React from "react";

export default function SQLServer_SPACE() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_SPACE</h1>
      <p>This is the SQLServer_SPACE component generated from the SQL JSON.</p>
    </div>
  );
}
